export const DB_ROLES = {
  SUPER_ADMIN: 'SuperAdmin',
  MANAGER: 'Gerente',
  OPERATOR: 'Operador',
  COMMON: 'UsuarioComum'
}

const ROLE_ALIASES = {
  superadmin: DB_ROLES.SUPER_ADMIN,
  1: DB_ROLES.SUPER_ADMIN,
  gerente: DB_ROLES.MANAGER,
  2: DB_ROLES.MANAGER,
  operador: DB_ROLES.OPERATOR,
  3: DB_ROLES.OPERATOR,
  usuariocomum: DB_ROLES.COMMON,
  readonly: DB_ROLES.COMMON,
  comum: DB_ROLES.COMMON,
  4: DB_ROLES.COMMON
}

export const normalizeRole = (role) => {
  if (role == null || role === '') return ''
  const raw = String(role).trim()
  return ROLE_ALIASES[raw.toLowerCase()] || raw
}
export const ANALYSIS_DURATION_VISIBLE_FROM = new Date(2026, 7, 1)

// set .NET API routes here, so that it's easier
// to change it if necessary
export const DB_ROUTES = {
  LOGIN: 'Employees/login',
  FORGOT_PASSWORD: 'Auth/forgot-password',
  RESET_PASSWORD: 'Auth/reset-password',
  GET_ALL_ANALYSES: 'Analyses/with-names',
  GET_ANALYSIS_BY_ID: id => `Analyses/${id}`,
  GET_ALL_ANALYSES_PAGED: (pageNumber, pageSize) => `Analyses/paged?pageNumber=${pageNumber}&pageSize=${pageSize}`,
  GET_ALL_COMPANIES: 'Company',
  GET_ALL_EMPLOYEES: 'Employees',
  GET_ALL_EQUIPMENTS: 'Equipments',
  GET_ALL_LOCATIONS: 'Location',
  GET_ANALYSES_BY_FILTERS: (filters) => `Analyses/filtered?${filters}`,
  GET_ANALYSES_STATISTICS_BY_YEAR: year => `AnalysesDetails/StatisticsByTimeInterval/year/${year}`,
  GET_ANALYSES_STATISTICS_BY_COMPANY_DATE: (year, startMonth, endMonth, companyId, groupBy = 'month', startDate = null, endDate = null, state = null, city = null) => {
    let url = `AnalysesDetails/StatisticsByTimeInterval/${year}/startMonth/${startMonth}/endMonth/${endMonth}/company/${companyId}?groupBy=${groupBy}`
    if (startDate) url += `&startDate=${startDate}`
    if (endDate) url += `&endDate=${endDate}`
    if (state) url += `&state=${encodeURIComponent(state)}`
    if (city) url += `&city=${encodeURIComponent(city)}`
    return url
  },
  GET_COMPANY_BY_ID: id => `Company/${id}`,
  PUT_COMPANY: id => `Company/${id}`,
  DELETE_COMPANY: id => `Company/${id}`,
  GET_COMPANY_EMPLOYEES: id => `/Company/Employees/EmployeeId?id=${id}`,
  GET_EMPLOYEE_BY_ID: id => `Employees/${id}`,
  GET_EMPLOYEES_BY_EQUIPMENT: id => `EmployeeEquipment/Equipment/${id}`,
  GET_EMPLOYEES_BY_MANAGER_ID: id => `Company/Employees/EmployeeId?id=${id}`,
  GET_EQUIPMENTS_BY_COMPANY: id => `Equipments/FromCompany?id=${id}`,
  GET_EQUIPMENTS_BY_EMPLOYEE: id => `EmployeeEquipment/Employee/${id}`,
  GET_ROLES: 'Role',
  POST_EMPLOYEE: 'Employees',
  POST_MANAGER: 'Employees/createManager',
  POST_EQUIPMENT_TO_EMPLOYEE: 'EmployeeEquipment',
  POST_COMPANY: 'Company',
  PUT_EMPLOYEE: id => `Employees/${id}`,
  PUT_EQUIPMENT: id => `Equipments/${id}`,
  DELETE_EMPLOYEE: id => `Employees/${id}`,
  DELETE_EQUIPMENT_FROM_EMPLOYEE: (employeeId, equipmentId) => `EmployeeEquipment/Employee/${employeeId}/Equipment/${equipmentId}`,
  MULTIPLE_ANALYSES_DELETE: 'Analyses/multiple',
  MULTIPLE_LAUDOS: type => `AwsPath/multiple/${type}`,
  GET_AWS_PATH: (id, type) => `/AwsPath/${type}/${id}`,
  GET_ANALYSIS_DETAILS: id => `AnalysesDetails/${id}/details`,
  GET_LAUDO_PDF: id => `AnalysesDetails/${id}/laudo`,
  EXPORT_LAUDOS_PDF_MULTIPLE: 'AnalysesDetails/laudo/multiple',
  GET_ANALYSIS_GRAINS: id => `AnalysesDetails/${id}/grains`,
  EXPORT_LAUDOS_EXCEL: companyId => `AnalysesDetails/export/excel/${companyId}`,
  EXPORT_LAUDOS_EXCEL_MULTIPLE: 'AnalysesDetails/export/excel/multiple',
  POST_ANALYSIS: 'Analyses',
  POST_ANALYSIS_COMPLETE: 'Analyses/complete',
  GET_ANALYSIS_DASHBOARD_SUMMARY: (params = {}) => {
    const query = new URLSearchParams()
    if (params.companyId) query.append('companyId', params.companyId)
    if (params.startDate) query.append('startDate', params.startDate)
    if (params.endDate) query.append('endDate', params.endDate)
    const qs = query.toString()
    return qs ? `AnalysisDashboard/summary?${qs}` : 'AnalysisDashboard/summary'
  },
  GET_ANALYSIS_DASHBOARD_CHART: (params = {}) => {
    const query = new URLSearchParams()
    if (params.companyId) query.append('companyId', params.companyId)
    if (params.equipmentId) query.append('equipmentId', params.equipmentId)
    if (params.startDate) query.append('startDate', params.startDate)
    if (params.endDate) query.append('endDate', params.endDate)
    if (params.groupBy) query.append('groupBy', params.groupBy)
    const qs = query.toString()
    return qs ? `AnalysisDashboard/analyses-chart?${qs}` : 'AnalysisDashboard/analyses-chart'
  },
  GET_ANALYSIS_DASHBOARD_RECENT_HISTORY: (params = {}) => {
    const query = new URLSearchParams()
    if (params.companyId) query.append('companyId', params.companyId)
    if (params.equipmentId) query.append('equipmentId', params.equipmentId)
    if (params.startDate) query.append('startDate', params.startDate)
    if (params.endDate) query.append('endDate', params.endDate)
    if (params.pageNumber) query.append('pageNumber', params.pageNumber)
    if (params.pageSize) query.append('pageSize', params.pageSize)
    const qs = query.toString()
    return qs ? `AnalysisDashboard/recent-history?${qs}` : 'AnalysisDashboard/recent-history'
  },
  GET_ANALYSIS_DASHBOARD_EQUIPMENT_USAGE: (params = {}) => {
    const query = new URLSearchParams()
    query.append('equipmentId', params.equipmentId)
    if (params.companyId) query.append('companyId', params.companyId)
    if (params.date) query.append('date', params.date)
    return `AnalysisDashboard/equipment-usage?${query.toString()}`
  },
  EXPORT_ANALYSIS_DASHBOARD_PDF: 'AnalysisDashboard/export/pdf'
}

// settings for logout due to inactivity
export const INACTIVITY_PERIOD = 120 * 60 * 1000 // 1 hour in milliseconds
export const INACTIVITY_EVENTS = ['click', 'keydown', 'touchstart']
